<template>
  <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
    <CellarMobile  v-if="matches" />
    <CellarDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import CellarMobile from "./Cellar_Mobile.vue";
  import CellarDesktop from "./Cellar_Desktop.vue";
 
  export default {
    name: 'Desktop',
    components: {
      MatchMedia,
      CellarMobile,
      CellarDesktop,
    },
  }
</script> 